import React from "react";

import { SectionPage } from "./section";
import { ResearchHubPage } from "./research-hub";


export const CollectionPage = props => {
    // Check if this collection has children - if so, render Research Hub page
    if (props?.data && props?.data?.hasChildren) {
        return <ResearchHubPage {...props} />
    }
    return <SectionPage {...props} />
};
